// extracted by mini-css-extract-plugin
export var centered = "_c-6";
export var flexible = "_c-5";
export var footer = "_c-k";
export var footerBorder = "_c-l";
export var header = "_c-c";
export var headerBorder = "_c-d";
export var headerDefault = "_c-g";
export var headerMedium = "_c-h";
export var headerPadding = "_c-e";
export var iconAndTitle = "_c-f";
export var large = "_c-4";
export var largePadding = "_c-a";
export var medium = "_c-3";
export var mediumPadding = "_c-9";
export var modal = "_c-0";
export var modalContainer = "_c-b";
export var noPadding = "_c-7";
export var skinny = "_c-1";
export var small = "_c-2";
export var smallPadding = "_c-8";
export var subtitle = "_c-j";
export var title = "_c-i";